/**
 * Created by shaun on 16/09/2017.
 */

import Vue from 'vue';

import {EMPTY, READY, LOADING, UPDATING, ERROR} from 'module/constants';
import common from 'module/common';
import {mapFieldMutation} from 'module/mapField';
import Moment from "moment/moment";

const SET_SELECTED_STATE = 'selectedState';
const SET_SELECTED_QUOTE = 'selectedQuote';
const SET_SELECTED_PLOT = 'selectedQuotePlot';
const SET_SELECTED_QUOTE_FIELD = 'setSelectedQuoteField';
const SET_FILES = 'setFiles';

const UPDATE_SAVING_STATE = 'savingState';
const UPDATE_LAST_SAVED = 'lastSaved';


// initial state
const state = {
  selected: {
    state: EMPTY
  }
};

//actions
const actions = {
  select({commit, dispatch, rootGetters}, scheduledJob) {
    return new Promise((resolve, reject) => {
      if (scheduledJob._refresh === true) {
        commit(SET_SELECTED_STATE, UPDATING);
      } else {
        commit(SET_SELECTED_STATE, LOADING);
      }

      common
        .httpPost('scheduledJob')
        .data({action: 'runNow', scheduledJob: scheduledJob._id, idToken: rootGetters['user/idToken']()})
        .then((res) => {
          if (scheduledJob._searchStore) {
            res.data._searchStore = scheduledJob._searchStore;
          }

          dispatch(scheduledJob._searchStore + '/updateRow', {
            rowId: scheduledJob._searchStoreRowId || null,
            rowToUpdate: res.data
          }, {root: true});

          resolve(res.data);
        }, (error) => {
          console.log('Error', error);
          dispatch('error/error', error, {root: true});
          commit(SET_SELECTED_STATE, ERROR);
          reject();
        });
    });
  }
};

//getters
const getters = {

};

// mutations
const mutations = {
  [SET_SELECTED_STATE](state, newState) {
    state.selected.state = newState;
  },
  [UPDATE_SAVING_STATE](state, {scheduledJobId, action, newState},) {
    let key = [scheduledJobId, action].join('_');

    if (newState !== READY && newState !== EMPTY) {
      Vue.set(state.saving, key, newState);
    } else if (state.saving[key]) {
      Vue.delete(state.saving, key);
    }
  }
};

export default {
  state,
  actions,
  getters,
  mutations
}